import { useState } from "react";
import { Anchor, Button, Divider, Group, Modal, Text } from "@mantine/core";
import { IconArrowRight, IconInvoice } from "@tabler/icons-react";
import { post } from "aws-amplify/api";
import InvoiceModal from "../Stripe/InvoiceModal";

interface SwitchPlanConfirmationModalProps {
  openedModal: boolean;
  setOpenedModal: (value: boolean) => void;
  switchPlanConfirmModalData: any;
  handleSwitchPlan: (
    lookupKey: string,
    force?: boolean,
    extraParams?: any,
  ) => void;
  products: any[];
}

const SwitchPlanConfirmationModal = ({
  setOpenedModal,
  openedModal,
  switchPlanConfirmModalData,
  handleSwitchPlan,
  products,
}: SwitchPlanConfirmationModalProps) => {
  const { lookupKey, priceId, customerId, subscriptionId } =
    switchPlanConfirmModalData;

  const [proratedInvoice, setProratedInvoice] = useState<any>(null);
  const [gettingProratedInvoice, setGettingProratedInvoice] = useState(false);
  const [openedProratedInvoiceModal, setOpenedProratedInvoiceModal] =
    useState(false);

  const getProratedInvoice = async () => {
    try {
      setGettingProratedInvoice(true);
      const postGetUpcomingInvoice = post({
        apiName: "StripeBackend",
        path: `/stripe/create-invoice-preview`,
        options: {
          body: {
            subscriptionId,
            priceId,
            customerId,
            prorationDate: Math.floor(Date.now() / 1000),
          },
        },
      });
      const resp = await postGetUpcomingInvoice.response;
      const result: any = await resp.body.json();
      setProratedInvoice(result?.invoice);
      setOpenedProratedInvoiceModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setGettingProratedInvoice(false);
    }
  };

  return (
    <>
      <Modal
        opened={openedModal}
        onClose={() => setOpenedModal(false)}
        centered
        title="Change Plan Confirmation"
      >
        <Text>
          You are about to switch to a new plan. This will prorate your current
          subscription.
        </Text>
        <Button
          variant="outline"
          mt="md"
          leftSection={<IconInvoice size={16} />}
          onClick={getProratedInvoice}
          loading={gettingProratedInvoice}
          disabled={gettingProratedInvoice}
        >
          Preview Prorated Invoice
        </Button>
        <Divider my="md" />
        <Anchor
          href="https://stripe.com/resources/more/prorated-billing-101-what-it-is-how-it-works-and-how-to-use-it"
          target="_blank"
        >
          Learn more about prorated billing <IconArrowRight size={16} />
        </Anchor>
        <Group mt="md" justify="flex-start">
          <Button onClick={() => setOpenedModal(false)} variant="default">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setOpenedModal(false);
              handleSwitchPlan(lookupKey, true, {});
            }}
          >
            Change Plan
          </Button>
        </Group>
      </Modal>
      {proratedInvoice && (
        <InvoiceModal
          opened={openedProratedInvoiceModal}
          onClose={() => setOpenedProratedInvoiceModal(false)}
          invoiceData={proratedInvoice}
          products={products}
          previewBeforeChange={true}
        />
      )}
    </>
  );
};

export default SwitchPlanConfirmationModal;
